











































import Vue from "vue";
import MaskedLoading from "@/components/atoms/MaskedLoading.vue";
import { showNotifyDialog } from "@/lib/dialog";
import { format } from "date-fns";
import ja from "date-fns/locale/ja";
import sanitizeHTML from "sanitize-html";
import isMobile from "ismobilejs";
import axiosBase from "axios";
const axios = axiosBase.create({
  baseURL: process.env.VUE_APP_MICROCMS_API_ENDPOINT,
  headers: { "X-API-KEY": process.env.VUE_APP_MICROCMS_API_KEY },
});

Vue.prototype.$sanitize = sanitizeHTML;

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    MaskedLoading,
  },
  props: {
    contestId: String,
  },
  async created() {
    const { contestId } = this;

    const contestRequest = await axios.get(`/contest/${contestId}`);
    if (contestRequest.status !== 200) {
      await showNotifyDialog({
        title: "エラー",
        content: "コンテスト情報の取得に失敗しました。",
      });
    }
    this.contest = contestRequest.data;
    this.isLoading = false;
  },
  data() {
    return {
      isLoading: true,
      contest: {},
    };
  },
  computed: {
    title() {
      const { contest } = this;
      return contest.contest;
    },
    department() {
      const { contest } = this;
      return contest.department;
    },
    free() {
      const { contest } = this;
      return contest.free;
    },
    image() {
      const { contest } = this;
      return contest.image.url;
    },
    referenceSource() {
      const { contest } = this;
      return contest.referenceSource;
    },
    deadline() {
      const { contest } = this;
      const { deadline } = contest;

      if (!deadline) return "-";

      return format(deadline, "YYYY/MM/DD（dd） HH:mm", { locale: ja });
    },
    genre() {
      const { contest } = this;
      return contest.genre;
    },
    category() {
      const { contest } = this;
      return contest.category;
    },
    award() {
      const { contest } = this;
      return contest.award;
    },
    content() {
      const { contest } = this;
      return contest.content;
    },
    homepage() {
      const { contest } = this;
      return contest.homepage;
    },
    entryForm() {
      const { contest } = this;
      return contest.entryForm;
    },
    isAnyMobile() {
      return isMobile().any;
    },
    width() {
      const { isAnyMobile } = this;
      return isAnyMobile ? "100%" : "auto";
    },
    height() {
      const { isAnyMobile } = this;
      return isAnyMobile ? "auto" : "300";
    },
  },
  methods: {
    onClickTransitionButton(url) {
      window.open(url);
    },
    onClickBack() {
      const { $router } = this;
      $router.back();
    },
    onClickBackContestList() {
      const { $router } = this;
      $router.push({ name: "contest" });
    },
  },
});

interface Props {
  contestId: string;
}

interface Data {
  isLoading: boolean;
  contest: Contest;
}

interface Computed {
  title: string;
  department: string;
  free: string;
  image: string | null;
  referenceSource: string;
  deadline: string;
  genre: string;
  category: string;
  award: string;
  content: string;
  homepage: string;
  entryForm: string;
  isAnyMobile: boolean;
  width: string;
  height: string;
}

interface Methods {
  onClickTransitionButton(url: string): void;
  onClickBack(): void;
  onClickBackContestList(): void;
}

type Contest = {
  [key: string]: any;
};
